import type * as React from 'react';
import { cn } from '../utils';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'outline' | 'destructive';
}

export function Badge({ className, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-[var(--color-border)] px-2 py-0.5 text-[11px] font-medium text-[var(--color-text-secondary)]',
        variant === 'secondary' && 'bg-[var(--color-surface)]',
        variant === 'outline' && 'bg-transparent',
        variant === 'destructive' && 'border-[var(--color-error)] text-[var(--color-error)]',
        className,
      )}
      {...props}
    />
  );
}
